module.exports = "/_next/static/images/energyBanner-08ddd607b980dcc031251573b7cd992e.webp";